<template>
    <div class="olf-wave-background d-flex justify-content-center align-items-center">
        <div class="login-sequence-box text-center card"
            :class="[$breakpoint.xsOnly ? 'p-4' : 'p-5']"
        >
            <img src="/assets/rebrandLogo2.png" alt="Online Fuels Logo" class="d-block mb-5 logo" />
            <form class="login w-100">
                <h1 class="heading-medium">You have been successfully logged out</h1>
                <h2 class="heading-medium">Have a great {{time | timecategory}}</h2>
                <i class="fas fa-check-circle fa-4x text-primary mx-auto d-block my-5"></i> 
                <router-link :to="{'name': 'Login'}" class="btn btn-primary">
                    Log back in?
                </router-link>
            </form>
        </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';

export default {
    mixins: [breakpoint],
    data(){
        return {
            time: new Date()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/_logins.scss";
</style>